import http from '../../axios/http';


let paramUtil = {
    memberParam : '',
}

paramUtil.memberParam = (data, callback) => {
    http.post({
        url: '/memberParam/getMemberParam',
        data: data,
        success: (res) => {
            callback(res);
        }
    });
}

export default paramUtil;